import { Injectable, Type } from '@angular/core';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';

@Injectable({ providedIn: 'root' })
export class NodeInspectorRegistry {
  private map = new Map<NodeType, Type<any>>();

  register(type: NodeType, component: Type<any>) {
    this.map.set(type, component);
  }

  get(type: NodeType): Type<any> | undefined {
    return this.map.get(type);
  }
}
